import { render, staticRenderFns } from "./medicineSearch.vue?vue&type=template&id=4e0a36f4"
import script from "./medicineSearch.vue?vue&type=script&lang=js"
export * from "./medicineSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports